"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestVisibilityConditionDtoMatchEnum = void 0;
exports.instanceOfDigestVisibilityConditionDto = instanceOfDigestVisibilityConditionDto;
exports.DigestVisibilityConditionDtoFromJSON = DigestVisibilityConditionDtoFromJSON;
exports.DigestVisibilityConditionDtoFromJSONTyped = DigestVisibilityConditionDtoFromJSONTyped;
exports.DigestVisibilityConditionDtoToJSON = DigestVisibilityConditionDtoToJSON;
exports.DigestVisibilityConditionDtoToJSONTyped = DigestVisibilityConditionDtoToJSONTyped;
/**
 * @export
 */
exports.DigestVisibilityConditionDtoMatchEnum = {
    Any: 'any',
    All: 'all'
};
/**
 * Check if a given object implements the DigestVisibilityConditionDto interface.
 */
function instanceOfDigestVisibilityConditionDto(value) {
    if (!('stepId' in value) || value['stepId'] === undefined)
        return false;
    if (!('optionIds' in value) || value['optionIds'] === undefined)
        return false;
    if (!('match' in value) || value['match'] === undefined)
        return false;
    return true;
}
function DigestVisibilityConditionDtoFromJSON(json) {
    return DigestVisibilityConditionDtoFromJSONTyped(json, false);
}
function DigestVisibilityConditionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'stepId': json['stepId'],
        'optionIds': json['optionIds'],
        'match': json['match'],
    };
}
function DigestVisibilityConditionDtoToJSON(json) {
    return DigestVisibilityConditionDtoToJSONTyped(json, false);
}
function DigestVisibilityConditionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'stepId': value['stepId'],
        'optionIds': value['optionIds'],
        'match': value['match'],
    };
}
